export class DependenciesNotDefinedError extends Error {
  constructor() {
    super('Dependencies are not defined. Is the component inside a <DependenciesContext.Provider>?');
  }
}
